import { render, staticRenderFns } from "./CustomerUISetting.vue?vue&type=template&id=06865bfa&scoped=true&"
import script from "./CustomerUISetting.vue?vue&type=script&lang=js&"
export * from "./CustomerUISetting.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUISetting.vue?vue&type=style&index=0&id=06865bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06865bfa",
  null
  
)

export default component.exports